import React from "react";
import { Card, Empty, Table, Typography } from "antd";

const { Text } = Typography;

export default function StatementCompareTable({
  title,
  data,
  columns,
  loading,
}) {
  return (
    <Card
      className="h-full rounded-2xl"
      title={title}
      styles={{ body: { padding: 0 } }}
    >
      {Array.isArray(data) && data.length > 0 ? (
        <Table
          rowKey="id"
          dataSource={data}
          columns={columns}
          loading={loading}
          pagination={false}
          scroll={{ x: 1100, y: 520 }}
        />
      ) : (
        <div className="p-8">
          <Empty description="No statements found" />
        </div>
      )}
    </Card>
  );
}